import logo from './logo.svg';
import './App.css';
import OperationGrid from './CostModelCreation/OperationArea/OperationArea';
import Header from './Component/Header';
import Header1 from './ElementCreation/Header1';
import ScopeGrid from './CostModelCreation/Scope/Grid';
import Popup from './Component/Popup';
import ManpowerList from './Component/ManPowerList';
import CategoryGrid from './CostModelCreation/Category/Category';
import SubCategoryGrid from './CostModelCreation/SubCategory/SubCategory';
import ModelName from './CostModelCreation/Model/ModelName';
import SalaryData from './Component/SalaryData';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Sidebar from './Component/SideBar';
import CostType from './ElementCreation/CostType/CostType';
import CostElement from './ElementCreation/CostElement/CostElement';
import SubCostElement from './ElementCreation/SubCostElement';
import ElementStandard from './ElementCreation/ElementStandard';
import Tempelate from './ElementCreation/Template/Tempelate';
import UOM from './ElementCreation/UOM/UOM';
import Approval from './ElementCreation/Approval';
import Assumptions from './ElementCreation/Assumption/Assumptions';
import Terms from './ElementCreation/Terms/Terms';
import Header2 from './ProjectCreation/Header2';
import Project from './ProjectCreation/Project';
import ProjectsPeriod from './ProjectCreation/ProjectPeriod/ProjectsPeriod'
import Operational from './ProjectCreation/OperationalAssummption/Operational'
import Financial from './ProjectCreation/FinancialAssumption/Financial'
import FinancialCreation from './ProjectCreation/FinancialAssumption/FinancialCreation'
import Costline from './ProjectCreation/CostLine'
import Contracts from './Component/Contracts';
import ContractsPopup from './Component/Contracts_popup';
import Contracts_header from './Component/Header/Contracts_header';
import CostLineCreate from './Component/CostLine/CostlineCreate';
import SubCostline from './Component/CostLine/SubCostline';
import Invoice from './Component/Invoice/Invoice';
import Invoice_header from './Component/Header/Invoice_header';
import Invoice_addNew from './Component/Invoice/Invoice_addNew';
import ChargeCode from './Component/Masters/ChargeCode';
import JobType from './Component/Masters/Jobtype';
import Masters_header from './Component/Masters/Masters_header'
import Popup2 from './ProjectCreation/Popup2';
import Project_popup_header from './Component/Header/Project_popup_header';
import Jobs_header from './Component/Header/Jobs_header';
import Jobs from './Component/Jobs/Jobs';
import Jobs_addnew from './Component/Jobs/Jobs_addnew';
import Jobs_module from './Component/Jobs/Jobs_module';
import MailHeader from './Component/MailConfig/MailHeader';
import MailQueue from './Component/MailConfig/MailQueue';
import ProjectCreation from './ProjectCreation/Popup2';
import ApprovalHeader from './Component/ApprovalConfig/ApprovalHeader';
import ApprovalConfiguration from './Component/ApprovalConfig/ApprovalConfiguration';
import ApprovalCreation from './Component/ApprovalConfig/ApprovalCreation';
import InvoiceEditModule from './Component/Invoice/invoiceEditModule';
import LoginPage from './LoginPage/LoginPage';
import { useLocation } from 'react-router-dom';
import CommonNavbar from './Navbar/CommonNavbar';
import User from './Component/Masters/User';
import RoleMaster from './Component/Masters/RoleMaster';
import Designation from './Component/Masters/Designation';
import UserCreation from './Component/Masters/UserCreation';
import DesignationCreation from './Component/Masters/DesignationCreation';
import RoleCreation from './Component/Masters/RoleCreation';
// import { PermissionProvider } from './PermissionContext';
// import { ModuleProvider } from './ModuleContext';

import { PermissionProvider } from './hooks/PermissionContext';
import { ModuleProvider } from './hooks/ModuleContext';
import GenerateSalesInvoice from './Component/Invoice/GenerateSalesInvoice';
import GenerateCostInvoice from './Component/Invoice/GenerateCostInvoice';
import GenerateSalesViewPage from './Component/Jobs/GenerateSalesViewPage';
import GenerateCostViewPage from './Component/Jobs/GenerateCostViewPage';
import SalesInvoice from './Component/Invoice/SalesInvoice';
import CostInvoice from './Component/Invoice/CostInvoice';
import SalesInvoiceViewPage from './Component/Invoice/SalesInvoiceViewPage';
import CostInvoiceViewPage from './Component/Invoice/CostInvoiceViewPage';
import TemplateCreation from './ElementCreation/Template/TemplateCreation';
import TemplateSubCostline from './ElementCreation/Template/TemplateSubCostline';
import Vendor from './Component/Masters/Vendor';
import VendorCreation from './Component/Masters/VendorCreation';
import ReportCreation from './Component/Report/ReportCreation';
import CostlineViewpage from './Component/CostLine/CostlineViewpage';
import SubCostlineViewPage from './Component/CostLine/SubCostlineViewPage';
import Dashboard from './Component/Dashboard/Dashboard';
import ContractViewPage from './Component/ContractViewPage';
import ProjectViewPage from './ProjectCreation/ProjectViewPage';
import { useEffect, useState } from 'react';
import { GlobalProvider, useGlobal } from './GlobalContext';
import { apiCallAdmin } from './services/api-service';
import { getOrgLogoApi } from './services/topbar-api';
import ForgetPassword from './LoginPage/ForgetPassword';
import ViewProfile from './Navbar/ViewProfile';
import VerifyCode from './LoginPage/VerifyCode';
import ResetPassword from './LoginPage/resetPassword';
import CommonFooter from './CommonFooter/CommonFooter';
import MailTemplateListingPage from './Component/MailConfig/MailTemplate/MailTemplateListingPage';
import MailTemplateCreation from './Component/MailConfig/MailTemplate/MailTemplateCreation';
import MailTemplateViewPage from './Component/MailConfig/MailTemplate/MailTemplateViewPage';
import PlantCodeListing from './Component/Masters/PlantCode/PlantCodeListing';
import PlantCodeCreation from './Component/Masters/PlantCode/PlantCodeCreation';
import BillingAutomationListing from './Component/BillingAutomation/BillingAutomationListing';
import BillingAutomationCreation from './Component/BillingAutomation/BillingAutomationCreation';
import BillingAutomationViewpage from './Component/BillingAutomation/BillingAutomationViewpage';


function AppContent() {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login' || location.pathname === '/forgetPassword' || location.pathname === '/verifyCode' || location.pathname === '/resetPassword';
  const [sidebarExpanded, setSidebarExpanded] = useState(false);

  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  const { rolePermissionList, setRolePermissionList, setUserType, setOrgImage } = useGlobal();
  const [loading, setLoading] = useState(true);

  // Login/auth pages are reachable without a valid session, so skip the
  // token/permission/org bootstrap entirely on those routes.
  const isPublicPage = isLoginPage || location.pathname === '/' || location.pathname === '/header';

  // Validate the session token on load and whenever the tab regains focus.
  useEffect(() => {
    if (isPublicPage) {
      setLoading(false);
      return;
    }

    const handleInvalidToken = () => {
      const currentURL = window.location.href;
      const redirectData = {
        redirectPath: currentURL,
        app: "accounts",
        ts: Date.now(),
      };
      // Tab-specific, cross-domain-safe redirect storage for post-login return.
      window.name = JSON.stringify(redirectData);
      document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      document.cookie = "mawalog=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      window.location.href = `${accountsUrl}`;
    };

    const checkToken = async () => {
      try {
        const response = await apiCallAdmin("get", "validatetoken", null, {});
        if (response.status === 401) {
          handleInvalidToken();
        }
      } catch (err) {
        console.error("Token validation failed:", err);
        handleInvalidToken();
      }
    };

    checkToken();

    const onFocus = () => checkToken();
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [isPublicPage, accountsUrl]);

  // Fetch role permissions and organization logo once on mount.
  useEffect(() => {
    if (isPublicPage) return;
    getRolePermission();
    getOrgLogo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPublicPage]);

  // Reload the app when the active organization changes elsewhere.
  useEffect(() => {
    const onOrgChanged = (event) => {
      if (event.detail === "changed") {
        window.location.reload();
      }
    };
    window.addEventListener("mawalog_org_changed", onOrgChanged);
    return () => window.removeEventListener("mawalog_org_changed", onOrgChanged);
  }, []);

  const getOrgLogo = async () => {
    try {
      const response = await getOrgLogoApi();
      if (response?.success === true) {
        setOrgImage(response.image ?? "");
      }
    } catch (err) {
      console.error("Error fetching org logo:", err);
    }
  };

  const getRolePermission = async () => {
    try {
      const response = await apiCallAdmin("get", "get_role_permission/22", null, {});
      if (response.status === 200 && response.data.success) {
        const userType = response.data.user_type;
        const rolePermissions = response.data.role_permission ?? [];

        setUserType(userType);
        setRolePermissionList(rolePermissions);

        localStorage.setItem("rolePermissionList", JSON.stringify(rolePermissions));
        localStorage.setItem("userType", userType ?? "");
      } else {
        setRolePermissionList([]);
      }
    } catch (err) {
      console.error("Error fetching role permissions:", err);
    } finally {
      setLoading(false);
    }
  };

  // True when the given menu has menu_permission and the requested permission.
  // eslint-disable-next-line no-unused-vars
  function checkPermission(menuName, permission) {
    return (
      rolePermissionList.findIndex(
        (element) => element["name"] === menuName && element["menu_permission"] === true && element[permission] === true
      ) > -1
    );
  }

  useEffect(() => {
    if (location.pathname !== "/salesBillPage") {
      sessionStorage.removeItem("separateChargesData");
      sessionStorage.removeItem("mergedChargesData");
    }
  }, [location.pathname]);

  if (!isPublicPage && loading) {
    return null;
  }

  return (

    <div className="App">
      {!isLoginPage && <Sidebar expanded={sidebarExpanded} setExpanded={setSidebarExpanded} />}
      <div style={
        !isLoginPage
          ? {
            marginLeft: sidebarExpanded ? "225px" : "70px",
            transition: "margin-left 0.3s ease",
            padding: "0px 5px 15px 3px",
          }
          : {}
      }>
        <Routes>
          {/* <Route path="/" element={<Header />} /> */}
          <Route path="/" element={<Navigate to="/scope" />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/header" element={<CommonNavbar />} />
          <Route path="/forgetPassword" element={<ForgetPassword />} />
          <Route path="/verifyCode" element={<VerifyCode />} />
          <Route path="/resetPassword" element={<ResetPassword />} />

          <Route path="/scope" element={<ScopeGrid />} />
          <Route path="/operation" element={<OperationGrid />} />
          <Route path="/category" element={<CategoryGrid />} />
          <Route path="/manpowerlist" element={<ManpowerList />} />
          <Route path="/pop" element={<Popup />} />
          <Route path="/subcategory" element={<SubCategoryGrid />} />
          <Route path="/modelname" element={<ModelName />} />
          <Route path="/Salarydata" element={<SalaryData />} />


          {/* //ElementCreation// */}

          <Route path="/elementcreation" element={<Header1 />} />
          <Route path="/CostType" element={<CostType />} />
          <Route path="/CostElement" element={<CostElement />} />
          <Route path="/SubCostElement" element={<SubCostElement />} />
          <Route path="/ElementStandard" element={<ElementStandard />} />
          <Route path="/Template" element={<Tempelate />} />
          <Route path='/TemplateSubcostline' element={<TemplateSubCostline />} />
          <Route path="/TemplateCreation" element={<TemplateCreation />} />
          <Route path="/UOM" element={<UOM />} />
          <Route path="/ApprovalLinkage" element={<Approval />} />
          <Route path="/Assumptions" element={<Assumptions />} />
          <Route path="/Terms" element={<Terms />} />


          {/* //ProjectCreation// */}

          <Route path="/projectcreation" element={<Header2 />} />
          <Route path="/projects" element={<Project />} />
          <Route path="/projects_popup_header" element={<Project_popup_header />} />
          <Route path="/projects_popup" element={<ProjectCreation />} />
          <Route path="/projectviewpage" element={<ProjectViewPage />} />
          <Route path="/projectsPeriod" element={<ProjectsPeriod />} />
          <Route path="/opperationalAssumption" element={<Operational />} />
          <Route path="/financialAssumption" element={<Financial />} />
          <Route path="/financialCreation" element={<FinancialCreation />} />
          <Route path="/costLine" element={<Costline />} />
          <Route path="/costLine_add_elements" element={<CostLineCreate />} />
          <Route path='/subcostline' element={<SubCostline />} />
          <Route path='/costLineviewpage' element={<CostlineViewpage />} />
          <Route path='/subcostlineviewpage' element={<SubCostlineViewPage />} />

          {/* //Contracts// */}
          <Route path="/contract-header" element={<Contracts_header />} />
          <Route path="/contract" element={<Contracts />} />
          <Route path="/contracts_popup" element={<ContractsPopup />} />
          <Route path="/contractviewpage" element={<ContractViewPage />} />

          {/* //Billing// */}
          {/* <Route path="/billing_header" element={<Bill_header/>}/>
            <Route path="/billing" element={<Billing/>} />
            <Route path="/billing_popup" element={<BillingPopup/>}/> */}

          {/* Invoice */}
          <Route path="/invoice_header" element={<Invoice_header />} />
          <Route path="/invoice" element={<Invoice />} />
          <Route path="/invoice_addNew" element={<Invoice_addNew />} />
          <Route path="/invoiceEdit" element={<InvoiceEditModule />} />
          <Route path="/salesBillPage" element={<GenerateSalesInvoice />} />
          <Route path="/costBillPage" element={<GenerateCostInvoice />} />
          <Route path="/salesInvoice" element={<SalesInvoice />} />
          <Route path="/costInvoice" element={<CostInvoice />} />
          <Route path="/salesInvoiceViewPage" element={<SalesInvoiceViewPage />} />
          <Route path="/costInvoiceViewPage" element={<CostInvoiceViewPage />} />

          {/* masters */}
          <Route path="/masters_header" element={<Masters_header />} />
          <Route path="/chargecode" element={<ChargeCode />} />
          <Route path="/jobtype" element={<JobType />} />
          <Route path='/plantCode' element={<PlantCodeListing />} />
          <Route path='/plantCodeCreation' element={<PlantCodeCreation />} />
          <Route path="/user" element={<User />} />
          <Route path="/userProfile" element={<ViewProfile />} />
          <Route path='/userCreation' element={<UserCreation />} />
          <Route path="/roleMaster" element={<RoleMaster />} />
          <Route path="/roleCreation" element={<RoleCreation />} />
          <Route path="/designation" element={<Designation />} />
          <Route path='/designationCreation' element={<DesignationCreation />} />
          <Route path='/vendor' element={<Vendor />} />
          <Route path='/vendorCreation' element={<VendorCreation />} />

          {/* jobs */}

          <Route path="/jobs_header" element={<Jobs_header />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/jobs_addnew" element={<Jobs_addnew />} />
          <Route path="/jobs_module" element={<Jobs_module />} />
          <Route path="/SalesViewPage" element={<GenerateSalesViewPage />} />
          <Route path="/CostViewPage" element={<GenerateCostViewPage />} />

          {/* Approval Config */}

          <Route path="/approval_header" element={<ApprovalHeader />} />
          <Route path="/approval_config" element={<ApprovalConfiguration />} />
          <Route path="/approval_creation" element={<ApprovalCreation />} />

          {/* Report */}
          <Route path="/report" element={<ReportCreation />} />

          {/* Mail Config */}

          <Route path="/mail_header" element={<MailHeader />} />
          <Route path="/mail_queue" element={<MailQueue />} />
          <Route path="/mailTemplate" element={<MailTemplateListingPage />} />
          <Route path="/mailTemplateCreation" element={<MailTemplateCreation />} />
          <Route path="/mailTemplateViewPage" element={<MailTemplateViewPage />} />
          {/* <Route path="/mail_trigger" element={<Jobs_addnew />} /> */}

          {/* Dashboard */}
          <Route path="/dashboard" element={< Dashboard />} />


          {/* Billing Automation */}
          <Route path="/billingAutomation" element={<BillingAutomationListing />} />
          <Route path="/billingAutomationCreation" element={<BillingAutomationCreation />} />
          <Route path="/billingAutomationViewpage" element={<BillingAutomationViewpage />} />

        </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <GlobalProvider>
        <PermissionProvider>
          <ModuleProvider>
            <AppContent />
          </ModuleProvider>
        </PermissionProvider>
      </GlobalProvider>
    </Router>
  );
}

export default App;
